import merge from 'lodash/fp/merge';

import { withPageStateProvider as _withPageStateProvider } from '@traveloka/rps';
export { pageState } from '@traveloka/rps';

import config from './pageStateConfig';

export const withPageStateProvider = (_config = {}) =>
  _withPageStateProvider(merge(config, _config));
